// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Afidium
import { BookingMainComponent } from './booking-main.component';
import { CardFormModule } from 'libraries/module/formbuilder/forms/card-form/card-form.module';
import { ChipsModule } from 'libraries/module/formbuilder/fields/chips/chips.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { BookingSavedSearchedSummaryModule } from '../../../pages/sasha-home/components/booking-saved-searched-summary/booking-saved-searched-summary.module';
import { SashaSideLinksModule } from 'app_sasha/pages/sasha-home/components/sasha-side-links/sasha-side-links.module';
import { BookingResultsContainerModule } from '../../../pages/booking-search-result/components/booking-results-container/booking-results-container.module';
import { PermissionModule } from 'libraries/permission/permission.module';

@NgModule({
    imports: [
        CommonModule,
        CardFormModule,
        ChipsModule,
        ButtonModule,
        BookingSavedSearchedSummaryModule,
        SashaSideLinksModule,
        BookingResultsContainerModule,
        PermissionModule,
        ReactiveFormsModule,
        RouterModule,
    ],
    exports: [BookingMainComponent],
    declarations: [BookingMainComponent],
    providers: [],
})
export class BookingMainModule { }
